// extracted by mini-css-extract-plugin
export default {"dashboard_container":"dashboard_dashboard_container__6auzY","widgets_wrapper":"dashboard_widgets_wrapper__C-SNK"};